import { z } from "zod";
import { CbhFeatureFlag } from "./CbhFeatureFlag";

export const cbhFeatureFlags = {
  [CbhFeatureFlag.HOME_HEALTH_ENABLED]: z.boolean(),
  [CbhFeatureFlag.INVOICE_HISTORY_REVAMP]: z.boolean(),
  [CbhFeatureFlag.HOME_HEALTH_PAY_RATES]: z.object({
    ADMISSION: z.object({
      RN: z.number(),
    }),
    DISCHARGE: z.object({
      RN: z.number(),
    }),
    RECERTIFICATION: z.object({
      RN: z.number(),
    }),
    REGULAR: z.object({
      CHHA: z.number(),
      CNA: z.number(),
      Caregiver: z.number(),
      LVN: z.number(),
      RN: z.number(),
    }),
    SUPERVISORY: z.object({
      RN: z.number(),
    }),
  }),
  [CbhFeatureFlag.INVOICE_DISPUTE_PAGE]: z.boolean(),
};

export type CbhFeatureFlags = {
  [K in keyof typeof cbhFeatureFlags]: z.infer<typeof cbhFeatureFlags[K]>;
};
